import React from 'react';
import { useLocation } from 'react-router';

const useScrollToTop = () => {
	const { pathname } = useLocation();

	React.useEffect(() => {
		window.scroll({ top: 0, left: 0, behavior: 'smooth' });
	}, [pathname]);

	return null;
};

export default useScrollToTop;
